import { memo } from 'react'
import { Button, styled } from '@mui/material'

const InsufficientButton = styled(Button)`
  height: 48px;
  border-radius: 24px;
`
export const InsufficientBalanceButton = memo(() => {
  return (
    <InsufficientButton fullWidth disabled variant="contained">
      Insufficient Balance
    </InsufficientButton>
  )
})
